// Sélecteur de période pour le dashboard

import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CalendarMonth, DateRange, CalendarToday } from '@mui/icons-material';
import { PeriodeDashboard } from '../../types/dashboard';

interface PeriodSelectorProps {
  periode: PeriodeDashboard;
  onChange: (periode: PeriodeDashboard) => void;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  periode,
  onChange,
}) => {
  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    newPeriode: PeriodeDashboard | null
  ) => {
    if (newPeriode !== null) {
      onChange(newPeriode);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
      <ToggleButtonGroup
        value={periode}
        exclusive
        onChange={handleChange}
        aria-label="période dashboard"
        size="small"
        color="primary"
      >
        <ToggleButton value={PeriodeDashboard.MOIS} aria-label="mois">
          <CalendarToday sx={{ mr: 1 }} />
          Mois
        </ToggleButton>
        <ToggleButton value={PeriodeDashboard.TRIMESTRE} aria-label="trimestre">
          <DateRange sx={{ mr: 1 }} />
          Trimestre
        </ToggleButton>
        <ToggleButton value={PeriodeDashboard.ANNEE} aria-label="année">
          <CalendarMonth sx={{ mr: 1 }} />
          Année
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
